import React, { useEffect, useState } from "react";
import {
  PlusOutlined,
  CheckCircleFilled,
  UploadOutlined,
  EditOutlined,
  ExclamationCircleFilled,
  DeleteOutlined
} from "@ant-design/icons";
import { Image, Typography, Upload, Button, message, Tooltip, Modal } from "antd";
import type { GetProp, UploadFile, UploadProps } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "store/Reducers";
import { updateProfileInfoes, uploadProfileImage } from "../Services";
import { openNotificationWithIcon } from "helpers/OpenNotificationWithIcon";
import { error } from "console";
import { setBackEndUlr } from 'helpers/SetBackEndUrl';
import { MazakaButton } from "apps/Common/MazakaButton";
import GeneralLoadingSpinner from "apps/Common/GeneralLoadingSpinner";
import { handleSetUserInfoes } from "../ClientSideStates";

const { confirm } = Modal;

type FileType = Parameters<GetProp<UploadProps, "beforeUpload">>[0];

const getBase64 = (file: FileType): Promise<string> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = (error) => reject(error);
  });

const beforeUpload = (
  file: FileType,
  setErrorMessage: (msg: string) => void
) => {
  const isAllowedType = /image\/(png|jpeg|jpg|webp|svg|gif)/.test(file.type);
  if (!isAllowedType) {
    setErrorMessage(
      "Sadece .png, .jpeg, .jpg, .webp, .svg ve .gif formatları kabul edilir"
    );
    return false;
  }
  const isSizeValid = file.size / 1024 / 1024 < 2; // 2MB
  if (!isSizeValid) {
    setErrorMessage("Resmin boyutu 2MB'yi aşamaz");
    return false;
  }
  setErrorMessage(""); // Clear any previous error messages
  return true;
};

interface AddOrUpdateProfileImageProps {
  fileList: UploadFile[];
  setFileList: any;
  type: string;
}

const AddOrUpdateProfileImage: React.FC<AddOrUpdateProfileImageProps> = ({
  fileList,
  setFileList,
  type,
}) => {
  const { Text } = Typography;
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  const [errorMessage, setErrorMessage] = useState(""); // Error message state
  const [isLoading,setIsLoading] = useState(false)
  const dispatch = useDispatch()
  const { userInfoes } = useSelector((state: RootState) => state.profile);

  

  const handlePreview = async (file: UploadFile) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj as FileType);
    }
    setPreviewImage(file.url || (file.preview as string));
    setPreviewOpen(true);
  };

  const handleChange: UploadProps["onChange"] = async ({
    fileList: newFileList,
  }) => {
    if (newFileList.length > 1) {
      setFileList([newFileList[newFileList.length - 1]]);
    } else {
      setFileList(newFileList);
    }
  };

    const handleRemove = async (file: UploadFile) => {
    return new Promise<boolean>(async (resolve) => {
      confirm({
        title: 'Resmi silmek istediğinize emin misiniz?',
        icon: <ExclamationCircleFilled />,
        content: 'Bu işlem geri alınamaz.',
        okText: 'Evet',
        cancelText: 'Hayır',
        async onOk() {
          try {
            setIsLoading(true);
            const data = {...userInfoes, photoUrl: ""};
            await updateProfileInfoes(data);
            setFileList([]);
            setErrorMessage("");
            openNotificationWithIcon("default", "Resim başarıyla silindi.");
            resolve(true);
          } catch (error: any) {
            openNotificationWithIcon("default", error?.message || "Silme hatası");
            resolve(false);
          } finally {
            setIsLoading(false);
          }
        },
        onCancel() {
          resolve(false);
        },
      });
    });
  };

  const handleButtonClick = () => {
    document.getElementById("hiddenFileInput")?.click();
  };

  const handleManualUpload = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const file: any = event.target.files?.[0];
    if (file && beforeUpload(file, setErrorMessage)) {
      const uploadFile: UploadFile = {
        uid: "-1",
        name: file.name,
        status: "done",
        originFileObj: file,
      };
      setFileList([uploadFile]);
    }
  };

  useEffect(() => {
    if (userInfoes?.photoUrl&&type==="profile") {
      console.log( setBackEndUlr()+"."+userInfoes?.photoUrl)
      setFileList([
        {
          uid: "-1",
          name: "",
          status: "done",
          url: setBackEndUlr()+"/"+userInfoes?.photoUrl,
          preview: setBackEndUlr()+"/"+userInfoes?.photoUrl,
        },
      ]);
    }
  }, [userInfoes]);

  const uploadButton = <PlusOutlined className="!text-xl !text-gray-400" />;

  const handleUploadSuccess = async (options: any) => {
    const { file } = options;
    const uploadFile: UploadFile = {
      uid: "-1", // Assign a unique identifier
      name: file.name,
      status: "done",
      originFileObj: file,
      preview: await getBase64(file),
    };
    setFileList([uploadFile]);
  };

  const handleSaveFile = async () => {
    const data = {
      userId: userInfoes?.id,
      file: fileList[0]?.originFileObj,
    };

    setIsLoading(true)

    try {
      const response = await uploadProfileImage(data);
      const user = {...userInfoes,photoUrl:response?.data}
      dispatch(handleSetUserInfoes({data:user}))
      openNotificationWithIcon("default", response?.message);
    } catch (error: any) {
      openNotificationWithIcon("default", error?.message);
      console.log("shomethings wrong during saving image");
    }
    finally{
      setIsLoading(false)
    }
  };

  return (
    <div className="!flex  gap-2">
      {
        isLoading?<>
        <GeneralLoadingSpinner/>
        </>:<>
      <div>
        {/* <Upload
          listType="picture-circle"
          fileList={fileList}
          onPreview={handlePreview}
          onChange={handleChange}
          beforeUpload={(file) => beforeUpload(file, setErrorMessage)}
          accept=".png,.jpeg,.jpg,.webp,.gif"
          className={`!bg-white !rounded-full ${
            errorMessage ? "error-border" : ""
          }`}
          onRemove={handleRemove}
          action={undefined}
          customRequest={handleUploadSuccess}
        >
          {fileList.length === 0 ? uploadButton : null}
        </Upload> */}
        <Upload
      listType="picture-circle"
      fileList={fileList}
      onPreview={handlePreview}
      onChange={handleChange}
      beforeUpload={(file) => beforeUpload(file, setErrorMessage)}
      accept=".png,.jpeg,.jpg,.webp,.gif"
      className={`!bg-white !rounded-full ${errorMessage ? "error-border" : ""}`}
      onRemove={handleRemove}
      action={undefined}
      customRequest={handleUploadSuccess}
      itemRender={(originNode, file) => (
        <div className="ant-upload-list-item-container">
          {originNode}
          <div className="ant-upload-list-item-actions">
            <Button
              icon={<DeleteOutlined />}
              onClick={(e) => {
                e.stopPropagation();
                handleRemove(file).then((success) => {
                  if (success) {
                    setFileList([]);
                  }
                });
              }}
              type="text"
              danger
            />
          </div>
        </div>
      )}
    >
      {fileList.length === 0 ? uploadButton : null}
    </Upload>

        {previewImage && (
          <Image
            wrapperStyle={{ display: "none" }}
            preview={{
              visible: previewOpen,
              onVisibleChange: (visible) => setPreviewOpen(visible),
              afterOpenChange: (visible) => !visible && setPreviewImage(""),
            }}
            src={previewImage}
          />
        )}
      </div>
      <div className="!flex flex-col items-start justify-center gap-2">
        {type === "profile" && (
          <>
            <div className="!flex items-center gap-3">
              <Text className="!text-black !text-xl">
                {`${userInfoes?.name || ""} ${userInfoes?.surname || ""}`}
              </Text>
              {userInfoes?.phoneNumber &&
                userInfoes?.numberPrefix &&
                userInfoes?.name &&
                userInfoes?.surname && (
                  <CheckCircleFilled className="!text-green-500 !text-xl" />
                )}
            </div>
          </>
        )}

        {fileList.length > 0 && (
          <>
            <div className="!flex !justify-start gap-3">
              <Button
                size="small"
                className=" !bg-black !text-white !text-xs"
                type="primary"
                icon={<EditOutlined />}
                onClick={handleButtonClick}
              >
                Resim Değiştir
              </Button>
              {type === "profile" && (
                <>
                  <MazakaButton
                    size="small"
                    className=" !bg-[#FFC502] !text-black !text-xs"
                    type="primary"
                    icon={<UploadOutlined />}
                    onClick={handleSaveFile}
                  >
                    Kaydet
                  </MazakaButton>
                </>
              )}
              <input
                id="hiddenFileInput"
                type="file"
                accept=".png,.jpeg,.jpg,.webp,.gif,.svg"
                style={{ display: "none" }}
                onChange={handleManualUpload}
              />
            </div>
          </>
        )}
      </div>
        
        </>
      }
    </div>
  );
};

export default AddOrUpdateProfileImage;
